import { render, staticRenderFns } from "./PhotoComment.vue?vue&type=template&id=c7a039e6"
import script from "./PhotoComment.vue?vue&type=script&lang=js"
export * from "./PhotoComment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports